import styled from 'styled-components';

export const ShowSchedulePostsButtonBox = styled.div`
  & > button {
    border-color: var(--gray-200);
    border-radius: var(--border-radius-lg);
  }

  & .btn-title {
    font-size: 1.125rem;
  }

  & .btn-detail {
    font-size: 0.75rem;
  }

  & .btn-icon {
    font-size: 1.25rem;
  }
`

ShowSchedulePostsButtonBox.displayName = 'ShowSchedulePostsButtonBox';
